import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useClassificationProgress(xUserId?: string) {
  const [remaining, setRemaining] = useState<number | null>(null);
  const [total, setTotal] = useState<number | null>(null);

  const fetchCounts = useCallback(async () => {
    if (!xUserId) return;
    let unclassifiedQuery = supabase
      .from("x_tweets")
      .select("*", { count: "exact", head: true })
      .eq("classified", false);
    let allQuery = supabase
      .from("x_tweets")
      .select("*", { count: "exact", head: true });
    if (xUserId !== "__global__") {
      unclassifiedQuery = unclassifiedQuery.eq("x_user_id", xUserId);
      allQuery = allQuery.eq("x_user_id", xUserId);
    }
    const [unclassified, all] = await Promise.all([unclassifiedQuery, allQuery]);
    setRemaining(unclassified.count ?? 0);
    setTotal(all.count ?? 0);
  }, [xUserId]);

  useEffect(() => {
    fetchCounts();
    // Poll every 5 seconds while there are unclassified tweets
    const interval = setInterval(fetchCounts, 5000);
    return () => clearInterval(interval);
  }, [fetchCounts]);

  const classified = total !== null && remaining !== null ? total - remaining : null;
  const progress = total && total > 0 ? Math.round(((total - (remaining ?? 0)) / total) * 100) : 100;

  return { remaining, total, classified, progress, refresh: fetchCounts };
}
